// import { lazy } from "react";
import React from "react";
import { Outlet } from "react-router-dom";

const ReportCenterRoot: React.FC = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ReportCenterRoot;
